<!--
 * @Author: your name
 * @Date: 2021-04-08 22:02:30
 * @LastEditTime: 2023-02-05 21:04:47
 * @LastEditors: yanglq-PC 61739363@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\page\GoodList.vue
-->
<template>
    <div class="layout">
        <MainHeader />
        <UserNav />
        <div class="main_box">
            <el-main>
                <el-table ref="multipleTable"
                          v-loading="isLoading"
                          :data="goods_list"
                          tooltip-effect="dark"
                          style="width: 100%">
                    <el-table-column label="商品名稱">
                        <template slot-scope="scope">
                            <img class="goods_img"
                                 :src="scope.row.image">
                            <div class="goods_info_box">
                                <p class="goods_name">
                                    {{ scope.row.name }}
                                </p>
                                <p class="goods_attr">
                                    購買屬性：{{ scope.row.attr }}
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="price"
                                     label="單價"
                                     width="140">
                        <template slot-scope="scope">
                            <span>{{ amountFormatte(scope.row.price) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="weight"
                                     label="重量(KG)"
                                     width="100">
                    </el-table-column>
                    <el-table-column label="數量"
                                     width="180">
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.num"
                                             :min="1"
                                             size="mini"
                                             controls-position="right"
                                             @change="ChangeNum(scope.row)"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="總金額"
                                     width="170">
                        <template slot-scope="scope">
                            {{ amountFormatte(scope.row.price*scope.row.num) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="總重量(KG)"
                                     width="120">
                        <template slot-scope="scope">
                            {{ (scope.row.weight*scope.row.num).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"
                                     width="120">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                       type="danger"
                                       @click="delete_msg(scope.row.order_goods_id, scope.row.name, scope.$index)">
                                刪除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="addr_box">
                    <div class="tit">
                        郵寄地址：
                    </div>
                    <el-input v-model="order_addr"
                              type="textarea"
                              placeholder="請輸入郵寄地址信息"
                              maxlength="200"
                              show-word-limit></el-input>
                </div>
                <div class="cart_btn_box">
                    <div class="right_box">
                        <div class="all_num">
                            <span>已選商品</span><em>{{ all_num }}</em><span>件</span>
                        </div>
                        <div class="all_weight">
                            <span>總重量：</span><em>{{ all_weight.toFixed(2) }}</em><span>KG</span>
                        </div>
                        <div class="all_money">
                            <span>合計：</span><em>{{ amountFormatte(all_price) }}</em>
                        </div>
                        <el-button class="cart_btn"
                                   @click="settleAccounts()">
                            結算
                        </el-button>
                    </div>
                </div>
            </el-main>
        </div>
        <MainFooter />
    </div>
</template>

<script>
import MainHeader from "@/components/Header";
import UserNav from "@/components/UserNav";
import MainFooter from "@/components/Footer";
import { getCartData } from "@/api/goodsAPI";
import { delete_cart, settle_accounts, changeGoodsNum } from "@/api/dataAPI";
import { changeImage, amountFormatte } from "@/utils";
import { mapState } from "vuex";
export default {
    components: {
        MainHeader,
        UserNav,
        MainFooter,
    },
    data() {
        return {
            goods_list: [], // 购物车商品列表
            all_num: 0, // 总数量
            all_weight: 0, // 总重量
            all_price: 0, // 总金额
            order_addr: "", // 邮寄地址
            isLoading: false, // 是否加载中
        };
    },
    computed: {
        ...mapState("loginUser", ["user_data", "islogining"]),
    },
    created() {
        this.getCartData();
    },
    methods: {
        amountFormatte,
        // 获取购物车
        async getCartData() {
            this.isLoading = true;
            let result = await getCartData();
            this.goods_list = changeImage(150, 150, result.goods_list, "thumb");
            this.getCountInfo();
            this.isLoading = false;
        },
        // 计算购物车总数量和总金额
        getCountInfo() {
            this.all_num = 0;
            this.all_price = 0;
            this.all_weight = 0;
            this.goods_list.forEach((element) => {
                this.all_num += element["num"];
                this.all_price += element["num"] * element["price"];
                this.all_weight += element["num"] * element["weight"];
            });
        },
        // 修改商品数量
        async ChangeNum(row) {
            this.isLoading = true;
            row.price = await changeGoodsNum(
                row.id,
                row.num,
                row.order_goods_id
            );
            this.getCountInfo();
            this.isLoading = false;
        },
        // 结算
        async settleAccounts() {
            // 只传递ID和数量
            let goods_info = [];
            console.log(this.goods_list);
            this.goods_list.forEach((element) => {
                goods_info.push({
                    order_goods_id: element.order_goods_id,
                    num: element.num,
                });
            });
            let resp = await settle_accounts(goods_info, this.order_addr);
            switch (resp.OPStatus) {
                case true:
                    this.$router.push({ name: "OrderList" });
                    this.$message({
                        type: "success",
                        message: "創建訂單成功",
                        center: true,
                    });
                    break;
                case "note":
                    this.$message({
                        type: "error",
                        message: resp.msg,
                        center: true,
                    });
                    break;
                case "Login":
                    this.$message({
                        type: "error",
                        message: resp.msg,
                        center: true,
                    });
                    this.$router.push({ name: "Login" });
                    break;
                default:
                    console.log(resp);
                    break;
            }
        },
        // 弹出删除确认框
        delete_msg(id, name, index) {
            this.$confirm(`您確定要從購物車中刪除 "${name}" 商品嗎？`, "提示", {
                confirmButtonText: "確定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let resp = await delete_cart(id);
                    switch (resp.OPStatus) {
                        case true:
                            // 删除数据表格该商品的数据
                            this.goods_list.splice(index, 1);
                            this.getCountInfo();
                            this.$message({
                                type: "success",
                                message: "已成功刪除該商品",
                                center: true,
                            });
                            break;
                        case "note":
                            this.$message({
                                type: "error",
                                message: resp.msg,
                                center: true,
                            });
                            break;
                        case "Login":
                            this.$message({
                                type: "error",
                                message: resp.msg,
                                center: true,
                            });
                            this.$router.push({ name: "Login" });
                            break;
                        default:
                            console.log(resp);
                            break;
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消刪除",
                    });
                });
        },
    },
};
</script>

<style scoped lang="scss">
.main_box {
    background: #f5f6f8 url("../../public/img/user-bg.jpg") center 0 no-repeat;
    min-height: 600px;
    height: auto;
    overflow: hidden;
    .el-main {
        width: 1240px;
        margin: 24px auto;
        padding: 0;
        background-color: rgba(255, 255, 255, 0);
        .goods_img {
            display: block;
            float: left;
            width: 100px;
            max-width: 100px;
            height: 100px;
            padding: 5px;
            border: 1px solid #dedede;
        }
        .goods_info_box {
            max-width: 265px;
            float: left;
            margin-left: 10px;
            .goods_name {
                padding: 10px 0;
                font-weight: bold;
            }
            .goods_attr {
                color: #999;
            }
        }
        .addr_box {
            background-color: #fff;
            padding-bottom: 15px;
            .tit {
                padding: 12px 10px;
            }
            .el-textarea {
                width: 90%;
                margin: 0 auto;
                display: block;
            }
        }
        .cart_btn_box {
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            background: #e5e5e5;
            .right_box {
                float: right;
                height: 48px;
                color: #3c3c3c;
                span {
                    float: left;
                    line-height: 48px;
                }
                em {
                    color: #f40;
                    font-weight: 700;
                    font-size: 20px;
                    font-family: tohoma, arial;
                    float: left;
                    line-height: 48px;
                    padding: 0 5px;
                    font-style: normal;
                }
                .all_num {
                    float: left;
                    margin-right: 30px;
                }
                .all_weight {
                    float: left;
                }
                .all_money {
                    float: left;
                    margin: 0 30px;
                    em {
                        font-size: 22px;
                        padding: 0 3px;
                    }
                }
            }
            .cart_btn {
                display: inline-block;
                width: 120px;
                height: 50px;
                line-height: 50px;
                background: #f40;
                text-align: center;
                font-family: "Lantinghei SC", "Microsoft Yahei";
                font-size: 20px;
                -webkit-border-radius: 2px;
                -moz-border-radius: 2px;
                -ms-border-radius: 2px;
                border-radius: 2px;
                text-decoration: none;
                color: #fff;
                float: right;
                padding: 0;
                border: none;
            }
            .cart_btn:hover {
                background-color: #ff7745;
            }
        }
    }
}
</style>
